import { render } from "./organisationUserActivity.vue?vue&type=template&id=c28d8b42&ts=true"
import script from "./organisationUserActivity.vue?vue&type=script&lang=ts"
export * from "./organisationUserActivity.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__